export default __webpack_public_path__ + "static/media/foto33_S_0440.f167193e.png";